import React from "react";

export default function GetStart({isPublic}) {
  return (
    <section id="hero" className="d-flex justify-content-center align-items-center">
    <div className="container position-relative aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
      <h1>Efforts brings quality,<br />Quality brings Success.</h1>
      <h2>We at ARA , apart from teaching,<br/> will guide every individuals to become productive.</h2>
      {isPublic && <a href="/signup" className="btn-get-started">Sign UP</a>}
      &nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://ara3educations.blogspot.com" className="btn-get-started">Our Blog</a>
    </div>
  </section>
  );
}